import {Component, LOCALE_ID, OnInit, Inject, ViewChild, OnDestroy, ChangeDetectorRef, Input} from '@angular/core';
import {CoverService} from "../../service-data/cover.service";
import {ResourceService} from "../../service-data/resource.service";
import {BodyService} from "../../service-data/body.service";
import {Book} from "../../../model/Book";
import {StartupService} from "../../service-ui/startup.service";

@Component({
  selector: 'app-diagnosis',
  templateUrl: './diagnosis.component.html',
  styleUrls: ['./diagnosis.component.css']
})

export class DiagnosisComponent implements OnInit {
  // @ViewChild('mainSideNav') mainSideNav: MatSidenav;
  @Input() book: Book;

  colors = {
      'WAITING': StartupService.colorAliases['background3'],
      'IN_PROGRESS': StartupService.colorAliases['background1'],
      'COMPLETE': StartupService.colorAliases['background2'],
      'ERROR': StartupService.colorAliases['errorBackground']
  };

    locale: string;

  constructor(private bodyService: BodyService, private coverService: CoverService, private resourceService: ResourceService) {
  }

  ngOnInit(): void {
    console.log(`Diagnosis BookID:${this.book ? this.book.ID : 'no book id'}`);
  }

  toggleCoverResourceToByPassRemoveExtraObjectsAndRasterize() {
    this.book.cover.resource.instructions = this.book.cover.resource.instructions && this.book.cover.resource.instructions['byPassRemoveExtraObjectAndRasterize'] === 'BYPASS' ? {} : {byPassRemoveExtraObjectAndRasterize: 'BYPASS'};
    this.book.cover.resource.problems = "";
    this.book.cover.resource.prepared = 'WAITING';
    this.book.cover.standardized = 'WAITING';
    this.resourceService.updateItem(this.book.cover.resource).subscribe( x => {
      console.log(`setCoverResourceToByPassRemoveExtraObjectsAndRasterize resource saved for bookID[${this.book.ID}]`);
    });
    this.coverService.updateItem(this.book.cover).subscribe( x => {
      console.log(`setCoverResourceToByPassRemoveExtraObjectsAndRasterize cover for bookID[${this.book.ID}]`);
    });
 }

  toggleBodyResourceToByPassRemoveExtraObjectsAndRasterize() {
    this.book.body.resource.instructions = this.book.body.resource.instructions && this.book.body.resource.instructions['byPassRemoveExtraObjectAndRasterize'] === 'BYPASS' ? {} : {byPassRemoveExtraObjectAndRasterize: 'BYPASS'};
    this.book.body.resource.problems = "";
    this.book.body.resource.prepared = 'WAITING';
    this.book.body.standardized = 'WAITING';
    this.resourceService.updateItem(this.book.body.resource).subscribe( x => {
      console.log(`setBodyResourceToByPassRemoveExtraObjectsAndRasterize resource saved for bookID[${this.book.ID}]`);
    });
    this.coverService.updateItem(this.book.cover).subscribe( x => {
      console.log(`setCoverResourceToByPassRemoveExtraObjectsAndRasterize cover for bookID[${this.book.ID}]`);
    });
  }

  retryCoverPrepare() {
    this.book.cover.resource.problems = "";
    this.book.cover.resource.prepared = 'WAITING';
    this.book.cover.standardized = 'WAITING';
    this.resourceService.updateItem(this.book.cover.resource).subscribe( x => {
      console.log(`retryCoverPrepare resource saved for bookID[${this.book.ID}]`);
    });
    this.coverService.updateItem(this.book.cover).subscribe( x => {
      console.log(`retryCoverPrepare cover for bookID[${this.book.ID}]`);
    });
  }

  retryBodyPrepare() {
    this.book.body.resource.problems = "";
    this.book.body.resource.prepared = 'WAITING';
    this.book.body.standardized = 'WAITING';
    this.resourceService.updateItem(this.book.body.resource).subscribe( x => {
      console.log(`retryBodyPrepare resource saved for bookID[${this.book.ID}]`);
    });
    this.bodyService.updateItem(this.book.body).subscribe( x => {
      console.log(`retryBodyPrepare body for bookID[${this.book.ID}]`);
    });
  }

  retryCoverStandardize() {
    this.book.cover.standardized = 'WAITING';
    this.coverService.updateItem(this.book.cover).subscribe( x => {
      console.log(`retryCoverStandardize cover for bookID[${this.book.ID}]`);
    });
  }

  retryBodyStandardize() {
    this.book.body.standardized = 'WAITING';
    this.bodyService.updateItem(this.book.body).subscribe( x => {
      console.log(`retryBodyStandardize body for bookID[${this.book.ID}]`);
    });
  }

  downloadFile(coverOrBody: string, stage: string) {
    const dateForFilename = new Date();
    const titleStanatized = this.book.title.replace(/[^a-zA-Z0-9._-]/g, '_');
    const filename = this.book.ID + '-' + titleStanatized + '-' + coverOrBody + '-' + stage + '-' + dateForFilename.getFullYear() + '.' + ( dateForFilename.getMonth() + 1 ) + '.' + dateForFilename.getDate() + '.PDF';
    switch (coverOrBody) {
      case 'COVER': {
        switch (stage) {
          case 'ORIGINAL': {
            this.resourceService.getOriginalURL(this.book.cover.resource.ID, filename).subscribe( x => {
              console.log(`downloading file for book ${this.book.ID} file ${filename}`);
              // const blob = new Blob([csv], {type: 'application/pdf'});
              const e = document.createEvent('MouseEvents');
              const a = document.createElement('a');
              a.download = filename;
              // a.href = window.URL.createObjectURL(blob);
              a.href = x;
              a.dataset.downloadurl = ['application/pdf', a.download, a.href].join(':');
              e.initEvent('click', true, false);
              a.dispatchEvent(e);
            });
            break;
          }
          case 'PREPARED': {
            this.resourceService.getPreparedURL(this.book.cover.resource.ID, filename).subscribe( x => {
              console.log(`downloading file for book ${this.book.ID} file ${filename}`);
              // const blob = new Blob([csv], {type: 'application/pdf'});
              const e = document.createEvent('MouseEvents');
              const a = document.createElement('a');
              a.download = filename;
              // a.href = window.URL.createObjectURL(blob);
              a.href = x;
              a.dataset.downloadurl = ['application/pdf', a.download, a.href].join(':');
              e.initEvent('click', true, false);
              a.dispatchEvent(e);
            });
            break;
          }
          case 'STANDARDIZED': {
            this.coverService.getStandardizedURL(this.book.cover.ID, filename).subscribe( x => {
              console.log(`downloading file for book ${this.book.ID} file ${filename}`);
              // const blob = new Blob([csv], {type: 'application/pdf'});
              const e = document.createEvent('MouseEvents');
              const a = document.createElement('a');
              a.download = filename;
              // a.href = window.URL.createObjectURL(blob);
              a.href = x;
              a.dataset.downloadurl = ['application/pdf', a.download, a.href].join(':');
              e.initEvent('click', true, false);
              a.dispatchEvent(e);
            });
            break;
          }
        }
        break;
      }
      case 'BODY': {
        switch (stage) {
          case 'ORIGINAL': {
            this.resourceService.getOriginalURL(this.book.body.resource.ID, filename).subscribe( x => {
              console.log(`downloading file for book ${this.book.ID} file ${filename}`);
              // const blob = new Blob([csv], {type: 'application/pdf'});
              const e = document.createEvent('MouseEvents');
              const a = document.createElement('a');
              a.download = filename;
              // a.href = window.URL.createObjectURL(blob);
              a.href = x;
              a.dataset.downloadurl = ['application/pdf', a.download, a.href].join(':');
              e.initEvent('click', true, false);
              a.dispatchEvent(e);
            });
            break;
          }
          case 'PREPARED': {
            this.resourceService.getPreparedURL(this.book.body.resource.ID, filename).subscribe( x => {
              console.log(`downloading file for book ${this.book.ID} file ${filename}`);
              // const blob = new Blob([csv], {type: 'application/pdf'});
              const e = document.createEvent('MouseEvents');
              const a = document.createElement('a');
              a.download = filename;
              // a.href = window.URL.createObjectURL(blob);
              a.href = x;
              a.dataset.downloadurl = ['application/pdf', a.download, a.href].join(':');
              e.initEvent('click', true, false);
              a.dispatchEvent(e);
            });
            break;
          }
          case 'STANDARDIZED': {
            this.bodyService.getStandardizedURL(this.book.body.ID, filename).subscribe( x => {
              console.log(`downloading file for book ${this.book.ID} file ${filename}`);
              // const blob = new Blob([csv], {type: 'application/pdf'});
              const e = document.createEvent('MouseEvents');
              const a = document.createElement('a');
              a.download = filename;
              // a.href = window.URL.createObjectURL(blob);
              a.href = x;
              a.dataset.downloadurl = ['application/pdf', a.download, a.href].join(':');
              e.initEvent('click', true, false);
              a.dispatchEvent(e);
            });
            break;
          }
        }
        break;
      }
    }
  }
}

